export default "__VITE_ASSET__qK8usDVl__"